import { Injectable } from '@angular/core';
import {AngularFirestore} from '@angular/fire/firestore';
import {SessionService} from './session.service';
import {CommonService} from './common.service';
import {MessageService} from './message.service';
import {MasterService} from './master.service';
import {COLLECTION_NAME} from '../../shared/constants';
import {Keisha} from '../../shared/interfaces/keisha';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  selectedFarmId: string | null;
  selectedKeishas: Keisha[] = [];
  constructor(private db: AngularFirestore,
              private sessionService: SessionService,
              private commonService: CommonService,
              private messageService: MessageService,
              private masterService: MasterService) {
    // 所属農場を初期値としてセット
    this.selectedFarmId = this.commonService.getName(this.masterService.keishaMaster,
      this.sessionService.session.personalSetting?.shozokuKeishaId, 'farmId');
  }

  /**
   *
   */
  selectedFarmChanged() {
    this.selectedKeishas = this.masterService.keishaMaster.filter(keisha => {
      return keisha.farmId === this.selectedFarmId && !keisha.isDeleted;
    });
  }

  /**
   *
   * @param collectionName
   */
  genCustomerRootCollectionRef(collectionName: string) {
    const customerId = this.sessionService.session.personalSetting.customerId;
    return this.db.collection(COLLECTION_NAME.CUSTOMERS).doc(customerId).collection(collectionName);
  }

  /**
   *
   * @param keishaId
   */
  getKeishaHibetsuFile(keishaId: string) {
    return firstValueFrom(this.genCustomerRootCollectionRef(COLLECTION_NAME.KEISHAMASTER).doc(keishaId)
      .collection(COLLECTION_NAME.KEISHAHIBETSUFILE).doc(this.commonService.getDateWithString()).get());
  }
}
